interface TrackModalVisibilityOptions {
  sessionStorageKey: string;
  displayCountKey: string;
  maxDisplayCount?: number;
}

export const trackModalVisibility = ({
  sessionStorageKey,
  displayCountKey,
  maxDisplayCount = 3,
}: TrackModalVisibilityOptions) => {
  const dismissedThisSession = window.sessionStorage.getItem(sessionStorageKey) === '1';
  let showModal = false;
  let displayCount = window.localStorage.getItem(displayCountKey)
    ? parseInt(window.localStorage.getItem(displayCountKey), 10)
    : 0;

  if (!dismissedThisSession && displayCount < maxDisplayCount) {
    window.localStorage.setItem(displayCountKey, `${displayCount + 1}`);

    showModal = true;
    displayCount += 1;
  }

  return { showModal, displayCount };
};
